import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
    name: "WearehouseManagement",
    components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCollapse, BCard, BFormGroup, BFormInput, BTable,
    ProductSearch, 
    },
    directives: {
    'b-toggle': VBToggle,
    },
    mixins: [mixins],
    data() {
        return {
            productSelect: null,  
            destinationAgency: null,
            isButtonDisabled: false,
            productSku: "", 
            product: "", 
            productId: "",
            idParams: false,
        }
    },
    async mounted() {
        if (this.$route.params.id) {
            this.productId = this.$route.params.id;
            this.idParams = true;
            this.requestProduct();
        }
    },
    methods: {
        selectProduct(product) {
            if(this.product){
                this.$root.notify(
                    "بیشتر از یک محصول نمیشه وارد کرد.",
                    "warning"
                );
                return;
            }
            this.product = product;
            this.product.varieties.forEach(variety => {  
                console.log(variety,'varietyvariety');
                // variety.quantity = variety.balance;  
            });  
        },
        async requestProduct() {
            try {
                if(this.product){
                    this.$root.notify(
                        "بیشتر از یک محصول نمیشه وارد کرد.",
                        "warning"
                    );
                    return;
                }
                this.disabled = true;
                if (!this.$route.params || !this.$route.params.id) {
                    const response = await this.$axios.get("admin/mini_orders/search", {
                        params: {
                            sku: this.productSku,
                            refund: false,
                        },
                    });
                    const variety = response.data.data.variety;
                    this.productId = variety.product.id;
                }
                const responseProduct = await this.$axios.get("admin/products/" + this.productId);
                this.product = responseProduct.data.data.product;
                console.log(this.product,'product');
                
                this.product.varieties.forEach(variety => {  
                console.log(variety,'varietyvariety');
                    // variety.quantity = foundBalance ? foundBalance.balance : 0;  
                });
            } catch (e) {
                this.$root.notify(e);
            } finally {
                this.disabled = false;
                this.$nextTick(() => {  
                    this.$refs.productSku.focus();  
                });  
            }
        },
        async submitData() {  
            const data = {  
                product_id: this.product.id,  
                varieties: this.product.varieties.map(variety => ({  
                    id: variety.id,  
                    balance: variety.quantity,  
                }))  
            };  

            try {  
                const response = await this.$axios.post('admin/store-taking',data);  
                this.$root.notify(response.data.message, 'success');
                this.product = null; 
                this.$router.push('/admin/products');
            } catch (error) {  
                this.$root.notify(error)
            }  
        }  
    }
}
